var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.475 5H19.525C10.425 5 5 10.425 5 19.525V40.45C5 49.575 10.425 55 19.525 55H40.45C49.55 55 54.975 49.575 54.975 40.475V19.525C55 10.425 49.575 5 40.475 5ZM42.5 43.675C38.225 43.675 34.225 41.825 31.025 38.4C27.4 41.675 22.675 43.675 17.5 43.675C16.475 43.675 15.625 42.825 15.625 41.8C15.625 40.775 16.475 39.925 17.5 39.925C26.175 39.925 33.35 33.05 34.275 24.25H30H17.525C16.5 24.25 15.65 23.4 15.65 22.375C15.65 21.35 16.5 20.525 17.525 20.525H28.125V18.2C28.125 17.175 28.975 16.325 30 16.325C31.025 16.325 31.875 17.175 31.875 18.2V20.525H36.1C36.15 20.525 36.2 20.5 36.25 20.5C36.3 20.5 36.35 20.525 36.4 20.525H42.475C43.5 20.525 44.35 21.375 44.35 22.4C44.35 23.425 43.5 24.275 42.475 24.275H38.025C37.65 28.55 36.05 32.475 33.6 35.675C36.1 38.45 39.225 39.95 42.5 39.95C43.525 39.95 44.375 40.8 44.375 41.825C44.375 42.85 43.525 43.675 42.5 43.675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.d4fae74096232c7217c5b241333ced1d.svg";
export { ForwardRef as ReactComponent };